module.exports = __webpack_public_path__ + "static/img/player_head_18.addff9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_18.jpg
// module id = 6/u/
// module chunks = 1